// Enhanced hover behavior for thumbnails - Desktop only
document.addEventListener('DOMContentLoaded', function() {
  // Only enable hover behavior on desktop (non-touch devices)
  if (window.matchMedia('(min-width: 750px)').matches && !('ontouchstart' in window)) {
    const thumbnails = document.querySelectorAll('.thumbnail--hover-effect');
    
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('mouseenter', function() {
        // Trigger the existing click event on hover
        this.click();
      });
    });
  }
});